var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"time-bullet"},[_c('div',{staticClass:"month"},[_vm._v(_vm._s(_vm.month)+"月")])])
}
var staticRenderFns = []

export { render, staticRenderFns }